/** This function return the base url based process.env with country prefix if @prefix
 * param is defined. The returned url comes always without / at the end
 */
const getBaseUrl = () => {
  let baseUrl = 'https://www.crehana.com';

  if (process.env.NODE_ENV === 'development') {
    baseUrl = `http://localhost:3000`;
  }

  if (process.env.NODE_ENV === 'test') {
    baseUrl = `https://qa.crehana.co`;
  }

  return baseUrl;
};

export default getBaseUrl;
